if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      this.cartNotification.setActiveElement(document.activeElement);

      const submitButton = this.querySelector('[type="submit"]');

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          this.cartNotification.renderContents(parsedState);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }
  });
}

/* Sold-out sizes: strike through option buttons with no available variant (added Sep 2026) */
(function () {
  var css = ".product-form__input input[type='radio'].is-sold-out + label{border-color:rgba(var(--color-foreground),.1);color:rgba(var(--color-foreground),.4);text-decoration:line-through}" +
    ".product-form__input input[type='radio'].is-sold-out:checked + label{background-color:rgba(var(--color-foreground),.15);color:rgba(var(--color-foreground),.6)}";
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function update(picker) {
    var json = picker.querySelector('script[type="application/json"]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var fieldsets = Array.prototype.slice.call(picker.querySelectorAll('fieldset'));
    var selected = fieldsets.map(function (fs) {
      var c = fs.querySelector('input:checked');
      return c ? c.value : null;
    });
    fieldsets.forEach(function (fs, index) {
      fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var available = variants.some(function (v) {
          return v.available && v.options[index] === input.value &&
            v.options.every(function (o, i) { return i === index || o === selected[i]; });
        });
        input.classList.toggle('is-sold-out', !available);
        var label = input.nextElementSibling;
        if (label) {
          if (available) label.removeAttribute('aria-label');
          else label.setAttribute('aria-label', input.value + ' - ' + ((window.variantStrings && window.variantStrings.soldOut) || 'Sold out'));
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('variant-radios').forEach(function (picker) {
      update(picker);
      picker.addEventListener('change', function () { update(picker); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
